import React from "react";
import { motion } from "framer-motion";
import { useCases } from "../data/mock";
import { Reveal, ChapterTag, EASE } from "../lib/motion";

export const UseCasesSection = () => {
  return (
    <section id="examples" data-testid="usecases-section" className="py-24 sm:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <Reveal>
          <ChapterTag num="05" label="In real life" />
          <h2 className="mt-6 font-display font-semibold text-stone-900 tracking-tight text-3xl sm:text-4xl lg:text-5xl max-w-2xl leading-[1.1]">
            {useCases.heading}
          </h2>
          <p className="mt-5 text-stone-500 leading-relaxed max-w-2xl">{useCases.intro}</p>
        </Reveal>

        <div className="mt-14 columns-1 sm:columns-2 lg:columns-3 gap-5 [column-fill:balance]">
          {useCases.items.map((uc, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-30px" }}
              transition={{ duration: 0.55, delay: (i % 3) * 0.07, ease: EASE }}
              className="break-inside-avoid mb-5 rounded-2xl border border-stone-200 bg-[#FAF7F2] p-7 hover:border-brand-400/60 hover:shadow-[0_8px_30px_rgba(3,46,45,0.06)] hover:-translate-y-1 transition-all duration-300"
              data-testid={`usecase-card-${i}`}
            >
              <p className="font-display  text-lg md:text-xl text-stone-900 leading-snug">
                "{uc.quote}"
              </p>
              <div className="mt-4 h-px w-10 bg-[#A86532]/50" />
              <p className="mt-4 text-sm text-stone-600 leading-relaxed">{uc.response}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
